import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import {
  deleteUser,
  getAllUsers,
  getSingleUser,
  getUserAvailability,
  toggleActivation,
} from "./queries";

const usersApi = createApi({
  reducerPath: "usersApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    // get all users
    getAllUsers: builder.query({
      providesTags: ["all_users"],
      query: getAllUsers,
    }),

    //get user availability
    getUserAvailability: builder.query({
      providesTags: ["user_availability"],
      query: getUserAvailability,
    }),

    // get single user
    getSingleUser: builder.query({
      providesTags: ["user"],
      query: getSingleUser,
    }),

    // toggle user account activation
    toggleActivation: builder.mutation({
      invalidatesTags: ["all_users"],
      query: toggleActivation,
      transformResponse: (response) => response.success,
    }),

    // delete user account
    deleteUser: builder.mutation({
      invalidatesTags: ["all_users"],
      query: deleteUser,
    }),
  }),
});

export const {
  useGetAllUsersQuery,
  useGetSingleUserQuery,
  useGetUserAvailabilityQuery,
  useToggleActivationMutation,
  useDeleteUserMutation,
  reducer: usersApiReducer,
  reducerPath: usersApiReducerPath,
  middleware: usersApiMiddleWare,
} = usersApi;
